<template>
  <VueDatePicker v-model="date" :format="computedFormat" :enable-time-picker="true" week-start="0" locale="ja"
    placeholder="日付を選択" select-text="OK" cancel-text="NG" :show-now-button="true" now-button-label="現在を選択"
    :name="attribute_name"></VueDatePicker>
</template>

<script setup>
import { ref, computed } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';

const props = defineProps({
  value: [String, Number],
  no_sec: Boolean,
  attribute_name: String
});

const attribute_name = ref(props.attribute_name || 'date');

const parseDate = (value) => {
  console.log("Parsing value:", value);
  const format = props.no_sec ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm';  // moment.jsの形式

  if (!value) {
    //const defaultDate = new Date(Date.now() + 24 * 60 * 60 * 1000);
    const defaultDate = null;
    console.log("No value provided, using default:", defaultDate);
    return defaultDate;
  }

  const parsedDate = moment(value, format, true);
  console.log("Parsed date (isValid):", parsedDate.isValid(), "Parsed date:", parsedDate.toDate());

  return parsedDate.isValid() ? parsedDate.toDate() : new Date(Date.now() + 24 * 60 * 60 * 1000);
};

const date = ref(parseDate(props.value));

// computedFormatをcomputedプロパティとして定義
const computedFormat = computed(() => {
  // date-fns用に変更：YYYYをyyyyに変更
  return props.no_sec ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm';  // これを修正
});
</script>
